import { defaultStatus } from '../defaultState/defaultState'
import {
  AUTH_RESET_STATE,
  CHANGE_PASSWORD_FAILURE,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGOUT,
  REFRESH_TOKEN_FAILURE,
  REFRESH_TOKEN_REQUEST,
  REFRESH_TOKEN_SUCCESS,
  REGISTER_FAILURE,
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  REQUEST_OTP_FAILURE,
  REQUEST_OTP_REQUEST,
  REQUEST_OTP_SUCCESS,
  RESEND_OTP_FAILURE,
  RESEND_OTP_REQUEST,
  RESEND_OTP_SUCCESS,
  UPDATE_PASSWORD_FAILURE,
  UPDATE_PASSWORD_REQUEST,
  UPDATE_PASSWORD_SUCCESS,
  VERIFY_OTP_FAILURE,
  VERIFY_OTP_REQUEST,
  VERIFY_OTP_SUCCESS
} from './authType'

const initialState = {
  user: { 
    ...defaultStatus, 
    otpVerified: false,
    accessToken: null,
    refreshToken: null
  },
  newUser: { ...defaultStatus },
  registerOtp: { ...defaultStatus },
  forgotPassword: { ...defaultStatus },
  requestOtp: { ...defaultStatus },
  resendOtp: { ...defaultStatus },
  refreshToken: { ...defaultStatus },
  changePassword: { ...defaultStatus }
}

const AuthReducer = (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case LOGIN_REQUEST:
      return { ...state, user: { ...state.user, inProgress: true } }

    case LOGIN_SUCCESS:
      return { 
        ...state, 
        user: { 
          ...state.user, 
          success: true, 
          inProgress: false,
          error: false,
          successMessage: payload?.data?.message || "Login successful",
          user: payload?.user || {},
          accessToken: payload?.accessToken || null,
          refreshToken: payload?.refreshToken || null
        } 
      }

    case LOGIN_FAILURE:
      return {
        ...state,
        user: {
          ...state.user,
          inProgress: false,
          error: true,
          errorMessage: payload?.errorMessage || null,
          ...payload
        }
      }

    case LOGOUT:
      return { ...state, user: { ...defaultStatus } }

    case REGISTER_REQUEST:
      return {
        ...state,
        newUser: { ...state.newUser, inProgress: true, ...payload }
      }

    case REGISTER_SUCCESS:
      return {
        ...state,
        newUser: { ...state.newUser, success: true, ...payload }
      }

    case REGISTER_FAILURE:
      return {
        ...state,
        newUser: {
          ...state.newUser,
          error: true,
          errorMessage: payload?.errorMessage || null,
          errorFields: payload?.errorFields || null,
          ...payload
        }
      }

    case REQUEST_OTP_REQUEST:
      return {
        ...state,
        requestOtp: { ...state.requestOtp, inProgress: true, ...payload }
      }

    case REQUEST_OTP_SUCCESS:
      return {
        ...state,
        requestOtp: { ...state.requestOtp, success: true, ...payload }
      }

    case REQUEST_OTP_FAILURE:
      return {
        ...state,
        requestOtp: {
          ...state.requestOtp,
          error: true,
          errorMessage: payload?.errorMessage || null,
          ...payload
        }
      }

    case VERIFY_OTP_REQUEST:
      return {
        ...state,
        registerOtp: { ...state.registerOtp, inProgress: true, ...payload }
      }

    case VERIFY_OTP_SUCCESS:
      return {
        ...state,
        registerOtp: {
          ...state.registerOtp,
          success: true,
          message: payload?.message || null
        }
      }

    case VERIFY_OTP_FAILURE:
      return {
        ...state,
        registerOtp: {
          ...state.registerOtp,
          error: true,
          errorMessage: payload?.errorMessage || null,
          ...payload
        }
      }
      case REFRESH_TOKEN_REQUEST:
      return {
        ...state,
        refreshToken: { ...state.refreshToken, inProgress: true, ...payload }
      }

    case REFRESH_TOKEN_SUCCESS:
      return {
        ...state,
        refreshToken: {
          ...state.refreshToken,
          success: true,
          message: payload?.message || null
        }
      }

    case REFRESH_TOKEN_FAILURE:
      return {
        ...state,
        refreshToken: {
          ...state.refreshToken,
          error: true,
          errorMessage: payload?.errorMessage || null,
          ...payload
        }
      }
    case RESEND_OTP_REQUEST:
      return {
        ...state,
        resendOtp: { ...state.resendOtp, inProgress: true, ...payload }
      }

    case RESEND_OTP_SUCCESS:
      return {
        ...state,
        resendOtp: { ...state.resendOtp, success: true, ...payload }
      }

    case RESEND_OTP_FAILURE:
      return {
        ...state,
        resendOtp: {
          ...state.resendOtp,
          error: true,
          errorMessage: payload?.errorMessage || null,
          ...payload
        }
      }

    case UPDATE_PASSWORD_REQUEST:
      return {
        ...state,
        forgotPassword: {
          ...state.forgotPassword,
          inProgress: true,
          ...payload
        }
      }

    case UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        forgotPassword: { ...state.forgotPassword, success: true, ...payload }
      }

    case UPDATE_PASSWORD_FAILURE:
      return {
        ...state,
        forgotPassword: {
          ...state.forgotPassword,
          error: true,
          errorMessage: payload?.errorMessage || null,
          ...payload
        }
      }

    case CHANGE_PASSWORD_REQUEST:
      return {
        ...state,
        changePassword: {
          ...state.changePassword,
          inProgress: true,
          ...payload
        }
      }

    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        changePassword: { ...state.changePassword, success: true,error:false, ...payload }
      }

    case CHANGE_PASSWORD_FAILURE:
      return {
        ...state,
        changePassword: {
          ...state.changePassword,
          inProgress: false,
          error: true,
          success: false,
          errorMessage: payload?.errorMessage || null,
          ...payload
        }
      }

    case AUTH_RESET_STATE:
      return { ...initialState }

    default:
      return state
  }
}

export default AuthReducer